import { handleActions } from "redux-actions";
import { IBaseStoreState, IProgressive, progressActions } from "./base-reducers";
import { FileWithPreview } from "react-dropzone";
import { JOB_STATUSES } from "../constants/vetl";

export interface IUploadFilesResult {
    id: string;
    fileName: string;
    type: string;
    file: FileWithPreview;
}

export interface TransformState {
    id: string;
    namedInput: string;
    namedOutput: string;
    kind: string;
    status: JOB_STATUSES;
    artifactIdsList: Array<string>;
    persisted: boolean;
    unitsProcessed: number;
    progress: number;
    progressDescription: string;
    progressLabel: string;
    errorText: string;
}

export interface ISummary {
    fieldsMap: any[];
}

export interface IJob {
    id: string;
    revision: number;
    merchantId: string;
    description: string;
    transformsList: Array<object>;
    sourceId: string;
    sourceRevision: number;
    sinkId: string;
    sinkRevision: number;
    pipelineId: string;
    pipelineRevision: number;
    transformStateList: Array<TransformState>;
    status: JOB_STATUSES;
    runOnCreate: boolean;
    progress: number;
    createdAtMs: number;
    saveChainAsArtifacts: boolean;
    summary?: object;
    summariesMap: Array<[string, ISummary]>;
}

export interface IUploadJobPayload {
    message?: string;
    job?: IJob;
    errors?: string[];
}

export interface IUploadState extends IBaseStoreState<IUploadJobPayload> {
    isUploading: boolean;
    isProcessing: boolean;
    isFetching: boolean;
    payload: IUploadJobPayload;
    errors: string[];
}

export interface IUploadActionTypes {
    PROCESS: IProgressive;
    UPLOAD: IProgressive & { RESET_STATE: string };
    JOB: {
        POLL: {
            START: string;
            STOP: string;
        };
        FETCH: IProgressive;
        RESET: string;
    };
}

export const uploadActions = (TYPE: IUploadActionTypes) =>
    handleActions<IUploadState, IUploadJobPayload>(
        {
            ...progressActions<IUploadJobPayload, IUploadState>(TYPE.UPLOAD, "isUploading"),
            ...progressActions<IUploadJobPayload, IUploadState>(TYPE.JOB.FETCH, "isFetching"),
            [TYPE.PROCESS.START]: (state) => ({ ...state, isProcessing: true, errors: null }),
            [TYPE.PROCESS.SUCCESS]: (state) => ({ ...state, isProcessing: false, errors: null }),
            [TYPE.JOB.RESET]: (state) => ({ ...state, payload: null }),
        } as any,
        { isUploading: false, errors: null, payload: {}, isProcessing: false, isFetching: false },
    );
